var city = {
  citycode: [],
  adcode: "350000",
  name: "福建省",
  center: {
    lng: 119.296194,
    lat: 26.101082
  },
  districtList: [
    {
      citycode: "0593",
      adcode: "350900",
      name: "宁德市",
      center: {
        lng: 119.547729,
        lat: 26.666222
      },
      districtList: [
        {
          citycode: "0593",
          adcode: "350922",
          name: "古田县",
          center: {
            lng: 118.74603,
            lat: 26.578134
          }
        },
        {
          citycode: "0593",
          adcode: "350982",
          name: "福鼎市",
          center: {
            lng: 120.216559,
            lat: 27.324796
          }
        },
        {
          citycode: "0593",
          adcode: "350902",
          name: "蕉城区",
          center: {
            lng: 119.526284,
            lat: 26.660658
          }
        },
        {
          citycode: "0593",
          adcode: "350921",
          name: "霞浦县",
          center: {
            lng: 120.005267,
            lat: 26.885971
          }
        },
        {
          citycode: "0593",
          adcode: "350981",
          name: "福安市",
          center: {
            lng: 119.647871,
            lat: 27.088274
          }
        },
        {
          citycode: "0593",
          adcode: "350926",
          name: "柘荣县",
          center: {
            lng: 119.900597,
            lat: 27.23421
          }
        },
        {
          citycode: "0593",
          adcode: "350923",
          name: "屏南县",
          center: {
            lng: 118.985759,
            lat: 26.908256
          }
        },
        {
          citycode: "0593",
          adcode: "350925",
          name: "周宁县",
          center: {
            lng: 119.338998,
            lat: 27.104797
          }
        },
        {
          citycode: "0593",
          adcode: "350924",
          name: "寿宁县",
          center: {
            lng: 119.514589,
            lat: 27.45467
          }
        }
      ]
    },
    {
      citycode: "0591",
      adcode: "350100",
      name: "福州市",
      center: {
        lng: 119.296411,
        lat: 26.074286
      },
      districtList: [
        {
          citycode: "0591",
          adcode: "350123",
          name: "罗源县",
          center: {
            lng: 119.549129,
            lat: 26.490215
          }
        },
        {
          citycode: "0591",
          adcode: "350124",
          name: "闽清县",
          center: {
            lng: 118.863334,
            lat: 26.221099
          }
        },
        {
          citycode: "0591",
          adcode: "350122",
          name: "连江县",
          center: {
            lng: 119.539542,
            lat: 26.197737
          }
        },
        {
          citycode: "0591",
          adcode: "350181",
          name: "福清市",
          center: {
            lng: 119.384388,
            lat: 25.720081
          }
        },
        {
          citycode: "0591",
          adcode: "350112",
          name: "长乐区",
          center: {
            lng: 119.522952,
            lat: 25.962925
          }
        },
        {
          citycode: "0591",
          adcode: "350128",
          name: "平潭县",
          center: {
            lng: 119.789893,
            lat: 25.498767
          }
        },
        {
          citycode: "0591",
          adcode: "350103",
          name: "台江区",
          center: {
            lng: 119.31419,
            lat: 26.052826
          }
        },
        {
          citycode: "0591",
          adcode: "350125",
          name: "永泰县",
          center: {
            lng: 118.932746,
            lat: 25.867198
          }
        },
        {
          citycode: "0591",
          adcode: "350111",
          name: "晋安区",
          center: {
            lng: 119.328591,
            lat: 26.081963
          }
        },
        {
          citycode: "0591",
          adcode: "350102",
          name: "鼓楼区",
          center: {
            lng: 119.304507,
            lat: 26.082666
          }
        },
        {
          citycode: "0591",
          adcode: "350121",
          name: "闽侯县",
          center: {
            lng: 119.131362,
            lat: 26.150428
          }
        },
        {
          citycode: "0591",
          adcode: "350105",
          name: "马尾区",
          center: {
            lng: 119.439259,
            lat: 25.998657
          }
        },
        {
          citycode: "0591",
          adcode: "350104",
          name: "仓山区",
          center: {
            lng: 119.27322,
            lat: 26.047027
          }
        }
      ]
    },
    {
      citycode: "0594",
      adcode: "350300",
      name: "莆田市",
      center: {
        lng: 119.007662,
        lat: 25.454202
      },
      districtList: [
        {
          citycode: "0594",
          adcode: "350305",
          name: "秀屿区",
          center: {
            lng: 119.105177,
            lat: 25.318649
          }
        },
        {
          citycode: "0594",
          adcode: "350304",
          name: "荔城区",
          center: {
            lng: 119.014821,
            lat: 25.432268
          }
        },
        {
          citycode: "0594",
          adcode: "350322",
          name: "仙游县",
          center: {
            lng: 118.689745,
            lat: 25.373373
          }
        },
        {
          citycode: "0594",
          adcode: "350303",
          name: "涵江区",
          center: {
            lng: 119.116173,
            lat: 25.459057
          }
        },
        {
          citycode: "0594",
          adcode: "350302",
          name: "城厢区",
          center: {
            lng: 118.994261,
            lat: 25.419062
          }
        }
      ]
    },
    {
      citycode: "0595",
      adcode: "350500",
      name: "泉州市",
      center: {
        lng: 118.675724,
        lat: 24.874452
      },
      districtList: [
        {
          citycode: "0595",
          adcode: "350521",
          name: "惠安县",
          center: {
            lng: 118.781037,
            lat: 25.012449
          }
        },
        {
          citycode: "0595",
          adcode: "350582",
          name: "晋江市",
          center: {
            lng: 118.551659,
            lat: 24.781635
          }
        },
        {
          citycode: "0595",
          adcode: "350504",
          name: "洛江区",
          center: {
            lng: 118.671168,
            lat: 24.939319
          }
        },
        {
          citycode: "0595",
          adcode: "350583",
          name: "南安市",
          center: {
            lng: 118.385929,
            lat: 24.960056
          }
        },
        {
          citycode: "0595",
          adcode: "350527",
          name: "金门县",
          center: {
            lng: 118.319179,
            lat: 24.437147
          }
        },
        {
          citycode: "0595",
          adcode: "350581",
          name: "石狮市",
          center: {
            lng: 118.647945,
            lat: 24.731969
          }
        },
        {
          citycode: "0595",
          adcode: "350505",
          name: "泉港区",
          center: {
            lng: 118.915804,
            lat: 25.120399
          }
        },
        {
          citycode: "0595",
          adcode: "350525",
          name: "永春县",
          center: {
            lng: 118.29416,
            lat: 25.321849
          }
        },
        {
          citycode: "0595",
          adcode: "350524",
          name: "安溪县",
          center: {
            lng: 118.186295,
            lat: 25.056065
          }
        },
        {
          citycode: "0595",
          adcode: "350502",
          name: "鲤城区",
          center: {
            lng: 118.58652,
            lat: 24.908133
          }
        },
        {
          citycode: "0595",
          adcode: "350526",
          name: "德化县",
          center: {
            lng: 118.241104,
            lat: 25.492102
          }
        },
        {
          citycode: "0595",
          adcode: "350503",
          name: "丰泽区",
          center: {
            lng: 118.613007,
            lat: 24.890373
          }
        }
      ]
    },
    {
      citycode: "0592",
      adcode: "350200",
      name: "厦门市",
      center: {
        lng: 118.08891,
        lat: 24.479627
      },
      districtList: [
        {
          citycode: "0592",
          adcode: "350206",
          name: "湖里区",
          center: {
            lng: 118.146825,
            lat: 24.512858
          }
        },
        {
          citycode: "0592",
          adcode: "350203",
          name: "思明区",
          center: {
            lng: 118.082745,
            lat: 24.445676
          }
        },
        {
          citycode: "0592",
          adcode: "350213",
          name: "翔安区",
          center: {
            lng: 118.247911,
            lat: 24.618583
          }
        },
        {
          citycode: "0592",
          adcode: "350205",
          name: "海沧区",
          center: {
            lng: 118.032883,
            lat: 24.484688
          }
        },
        {
          citycode: "0592",
          adcode: "350211",
          name: "集美区",
          center: {
            lng: 118.097407,
            lat: 24.575976
          }
        },
        {
          citycode: "0592",
          adcode: "350212",
          name: "同安区",
          center: {
            lng: 118.150823,
            lat: 24.723299
          }
        }
      ]
    },
    {
      citycode: "0596",
      adcode: "350600",
      name: "漳州市",
      center: {
        lng: 117.647298,
        lat: 24.515297
      },
      districtList: [
        {
          citycode: "0596",
          adcode: "350604",
          name: "龙海区",
          center: {
            lng: 117.818485,
            lat: 24.446839
          }
        },
        {
          citycode: "0596",
          adcode: "350623",
          name: "漳浦县",
          center: {
            lng: 117.613783,
            lat: 24.11741
          }
        },
        {
          citycode: "0596",
          adcode: "350626",
          name: "东山县",
          center: {
            lng: 117.4295,
            lat: 23.702034
          }
        },
        {
          citycode: "0596",
          adcode: "350627",
          name: "南靖县",
          center: {
            lng: 117.357061,
            lat: 24.5151
          }
        },
        {
          citycode: "0596",
          adcode: "350628",
          name: "平和县",
          center: {
            lng: 117.314798,
            lat: 24.363831
          }
        },
        {
          citycode: "0596",
          adcode: "350629",
          name: "华安县",
          center: {
            lng: 117.53411,
            lat: 25.00445
          }
        },
        {
          citycode: "0596",
          adcode: "350605",
          name: "长泰区",
          center: {
            lng: 117.759119,
            lat: 24.625989
          }
        },
        {
          citycode: "0596",
          adcode: "350602",
          name: "芗城区",
          center: {
            lng: 117.653727,
            lat: 24.510937
          }
        },
        {
          citycode: "0596",
          adcode: "350603",
          name: "龙文区",
          center: {
            lng: 117.711188,
            lat: 24.503523
          }
        },
        {
          citycode: "0596",
          adcode: "350622",
          name: "云霄县",
          center: {
            lng: 117.334351,
            lat: 23.935433
          }
        },
        {
          citycode: "0596",
          adcode: "350624",
          name: "诏安县",
          center: {
            lng: 117.175314,
            lat: 23.711674
          }
        }
      ]
    },
    {
      citycode: "0597",
      adcode: "350800",
      name: "龙岩市",
      center: {
        lng: 117.017362,
        lat: 25.075884
      },
      districtList: [
        {
          citycode: "0597",
          adcode: "350824",
          name: "武平县",
          center: {
            lng: 116.100216,
            lat: 25.096139
          }
        },
        {
          citycode: "0597",
          adcode: "350821",
          name: "长汀县",
          center: {
            lng: 116.357581,
            lat: 25.833531
          }
        },
        {
          citycode: "0597",
          adcode: "350802",
          name: "新罗区",
          center: {
            lng: 117.036816,
            lat: 25.098942
          }
        },
        {
          citycode: "0597",
          adcode: "350881",
          name: "漳平市",
          center: {
            lng: 117.419823,
            lat: 25.290481
          }
        },
        {
          citycode: "0597",
          adcode: "350803",
          name: "永定区",
          center: {
            lng: 116.732216,
            lat: 24.724148
          }
        },
        {
          citycode: "0597",
          adcode: "350825",
          name: "连城县",
          center: {
            lng: 116.754472,
            lat: 25.710538
          }
        },
        {
          citycode: "0597",
          adcode: "350823",
          name: "上杭县",
          center: {
            lng: 116.419447,
            lat: 25.049867
          }
        }
      ]
    },
    {
      citycode: "0598",
      adcode: "350400",
      name: "三明市",
      center: {
        lng: 117.638919,
        lat: 26.263455
      },
      districtList: [
        {
          citycode: "0598",
          adcode: "350405",
          name: "沙县区",
          center: {
            lng: 117.792551,
            lat: 26.396843
          }
        },
        {
          citycode: "0598",
          adcode: "350430",
          name: "建宁县",
          center: {
            lng: 116.848488,
            lat: 26.833566
          }
        },
        {
          citycode: "0598",
          adcode: "350421",
          name: "明溪县",
          center: {
            lng: 117.202119,
            lat: 26.355938
          }
        },
        {
          citycode: "0598",
          adcode: "350428",
          name: "将乐县",
          center: {
            lng: 117.471127,
            lat: 26.728917
          }
        },
        {
          citycode: "0598",
          adcode: "350424",
          name: "宁化县",
          center: {
            lng: 116.654369,
            lat: 26.262298
          }
        },
        {
          citycode: "0598",
          adcode: "350404",
          name: "三元区",
          center: {
            lng: 117.646153,
            lat: 26.271653
          }
        },
        {
          citycode: "0598",
          adcode: "350423",
          name: "清流县",
          center: {
            lng: 116.816772,
            lat: 26.177658
          }
        },
        {
          citycode: "0598",
          adcode: "350481",
          name: "永安市",
          center: {
            lng: 117.365046,
            lat: 25.941671
          }
        },
        {
          citycode: "0598",
          adcode: "350426",
          name: "尤溪县",
          center: {
            lng: 118.190515,
            lat: 26.169942
          }
        },
        {
          citycode: "0598",
          adcode: "350429",
          name: "泰宁县",
          center: {
            lng: 117.175448,
            lat: 26.900244
          }
        },
        {
          citycode: "0598",
          adcode: "350425",
          name: "大田县",
          center: {
            lng: 117.846828,
            lat: 25.692535
          }
        }
      ]
    },
    {
      citycode: "0599",
      adcode: "350700",
      name: "南平市",
      center: {
        lng: 118.081325,
        lat: 27.382829
      },
      districtList: [
        {
          citycode: "0599",
          adcode: "350722",
          name: "浦城县",
          center: {
            lng: 118.541079,
            lat: 27.917804
          }
        },
        {
          citycode: "0599",
          adcode: "350723",
          name: "光泽县",
          center: {
            lng: 117.333812,
            lat: 27.541061
          }
        },
        {
          citycode: "0599",
          adcode: "350724",
          name: "松溪县",
          center: {
            lng: 118.785429,
            lat: 27.526028
          }
        },
        {
          citycode: "0599",
          adcode: "350703",
          name: "建阳区",
          center: {
            lng: 118.120392,
            lat: 27.331996
          }
        },
        {
          citycode: "0599",
          adcode: "350725",
          name: "政和县",
          center: {
            lng: 118.857703,
            lat: 27.366122
          }
        },
        {
          citycode: "0599",
          adcode: "350783",
          name: "建瓯市",
          center: {
            lng: 118.304712,
            lat: 27.023233
          }
        },
        {
          citycode: "0599",
          adcode: "350721",
          name: "顺昌县",
          center: {
            lng: 117.809433,
            lat: 26.793455
          }
        },
        {
          citycode: "0599",
          adcode: "350702",
          name: "延平区",
          center: {
            lng: 118.181806,
            lat: 26.637503
          }
        },
        {
          citycode: "0599",
          adcode: "350782",
          name: "武夷山市",
          center: {
            lng: 118.035321,
            lat: 27.756422
          }
        },
        {
          citycode: "0599",
          adcode: "350781",
          name: "邵武市",
          center: {
            lng: 117.492778,
            lat: 27.340672
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/fujian.js